/* global G */
import find from 'lib/sequence/component/children/find'
import sequenceModuleLogin from 'lib/sequence/module/login'
import transform from 'lib/sequence/model/transformer'
import create from 'lib/sequence/model/api/create'
import { asyncPipeSpread } from 'lib/util'

/**
 * Prepares the model data to be sent.
 *
 * @param {Gaia.AppModule.Spec} module  the current module object composition
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const setData = module => async (components, ...args) => {
  const model = module[G.MODEL]

  create(model)
  transform(model)

  return [components, ...args]
}

/**
 * Submits the model data.
 *
 * @param {Gaia.AppModule.Spec} module  the current module object composition
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const submitData = module => async (components, ...args) => {
  const model = module[G.MODEL]
  const modelData = model[G.STATE][G.DATA]
  const personData = model[G.CHILDREN].person[G.STATE][G.DATA]

  const { tabs } = components

  const httpAdapter = model[G.ADAPTER][G.HTTP]
  const { version } = model[G.PROPS]
  const { data: { id, token } = {} } = tabs[G.STATE]

  try {
    await httpAdapter.put({
      url: `/api/v${version}/public/register/${id}`,
      params: {
        token,
        password: modelData.value.password,
        person: personData,
      },
    })
  } catch (e) {
    console.error(e)
  }

  return [components, ...args]
}
/**
 * Registration Invite Submit Action
 *
 * @param {Gaia.AppModule.Spec} module
 * @returns {function(*): function(...[*]): Promise<*>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  setData(module),
  submitData(module),
  sequenceModuleLogin(module),
)(find(module[G.STATE][G.ACTION][G.COMPONENT]), ...args)
